import BaseAPI from 'api/api'
import { FindAllInterface } from 'api/api-interface'
/** UTIILS */

export interface TemplateTypeInterface {
    treatmentTemplateTypeName: string
    treatmentTemplateTypeNameEn?: string
    status: string
}



export default class TemplateTypeApi extends BaseAPI {
    static findAll(props: FindAllInterface): Promise<any> {
        return this.api.get('treatment-template-types', { params: { ...props } }).then((res) => res)
    }

    static create(playload: any) {
        return this.api.post('treatment-template-types', playload)
    }

    static findById(id: number): Promise<TemplateTypeInterface> {
        return this.api.get(`treatment-template-types/${id}`)
    }

    static update(id: number, body: TemplateTypeInterface) {
        return this.api.patch(`treatment-template-types/${id}`, body)
    }

    static updateStatus(id: number, status: string): Promise<any> {
        return this.api.patch(`treatment-template-types/${id}/status`, { id, status })
    }

    static remove(id: number) {
        return this.api.delete(`treatment-template-types/${id}`)
    }
}
